import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { IPbisAutomationCounterResult } from 'libs/domain';
import { BehaviorReportColumns, ColumnInfo, TemplateColumnKeys } from 'libs/shared';

import { ReportDatasourceService } from '@app/src/app/components/manager-report/services/report-datasource.service';

import { BHStudentSummaryInfo } from '../constants';
import { BmReportsService } from './bm-reports.service';

@Injectable()
export class BmReportsAutoCounterDatasourceService extends ReportDatasourceService<IPbisAutomationCounterResult> {
  summaryInfo = BHStudentSummaryInfo;

  constructor(_router: Router, private _pbisReportsService: BmReportsService) {
    super(_router, _pbisReportsService, BmReportsAutoCounterDatasourceService.name);
    const displayCol: ColumnInfo[] = [
      {
        key: TemplateColumnKeys.SUMMARY,
        header: 'Summary',
        columnClasses: ['w-16'],
      },
      {
        key: TemplateColumnKeys.HISTORY,
        header: 'History',
        columnClasses: ['w-16'],
      },
    ];
    super.setDisplayColumns(BehaviorReportColumns.AUTOMATION_COUNTER, displayCol);
  }

  async fetch(offset: number, limit: number) {
    return await this._pbisReportsService.getAutoCounter(offset, limit, this._currentSort);
  }
}
